import { client } from 'app/http';

export const createSmsCountry = async (code: string, prefix: string, status: 'ALLOW_ALL' | 'ALLOW_WHITELIST') => {
  const { data } = await client.post(`/admin/sms-countries`, { code, prefix, status });
  return data;
};
